import React, { useCallback, useEffect, useState } from 'react';
import { getQualificationTypes, getTags } from '../services/api';
import QualificationForm from './Qualification/QualificationForm';
import { errorToast } from './toast';

const Form = ({
  item,
  onChange,
  identifier = '',
  errors,
  setErrors,
  isDisabled = false,
  isOpen,
}) => {
  const [tagsList, setTagsList] = useState([]);
  const [qualificationTypes, setQualificationTypes] = useState([]);
  const getTagsData = useCallback(() => {
    (async () => {
      try {
        const tags = await getTags();
        const qualifications = await getQualificationTypes();
        setTagsList(tags);
        setQualificationTypes(qualifications);
      } catch {
        errorToast('Failed to fetch tags and qualifications');
      }
    })();
  }, [setTagsList]);

  useEffect(() => {
    if (isOpen) {
      getTagsData();
    }
  }, [isOpen]);

  return (
    <QualificationForm
      item={item}
      onChange={onChange}
      identifier={identifier}
      errors={errors}
      setErrors={setErrors}
      isDisabled={isDisabled}
      tagsList={tagsList}
      qualificationTypes={qualificationTypes}
      type={item.type}
      tooltipType="certifications"
    />
  );
};

export default Form;
